import React, { Component } from 'react'
import { connect } from 'react-redux'
import { DashboardBox } from 'components/core'
import { ContentHeader } from 'components/basic'
import dashboardItems from 'config/dashboard'
class Dashboard extends Component {
  componentDidMount () {
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: 'Dashboard'
    })
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Flow' subtitle='Dashboard' />
        <hr />
        <div className='event-configration'>
          {dashboardItems.map(item => <DashboardBox key={item.icon} {...item} />)}
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
Dashboard = connect(state => state.siteReducer)(Dashboard)
export default Dashboard



// WEBPACK FOOTER //
// ./src/views/core/dashboard.js